import { defineStore } from "pinia";

setInterval(() => {
  store().now = moment().unix();
}, 1000);

const store = defineStore("recorder", {
  state: () => ({
    now: moment().unix(),
    recordings: [],
    currently_recording: [],
  }),
  actions: {
    async getRecordings() {
      try {
        const response = await axios.get('/api/v1/recorder');
        this.recordings = response.data;
      } catch (error) {
        window.handleAxiosError(error);
      }
    },
    async getCurrentlyRecording() {
      try {
        const response = await axios.get('/api/v1/recorder/recording');
        this.currently_recording = response.data;
      } catch (error) {
        window.handleAxiosError(error);
      }
    },
  },
});

export default store;
